import { ProjectCard } from "./ProjectCard"
import styles from "./Styles/ProjectsSection.module.css"
import { SiJavascript } from "react-icons/si"
import { SiHtml5 } from "react-icons/si"
import { SiCss3 } from "react-icons/si"
import { SiNodedotjs } from "react-icons/si"
import { SiExpress } from "react-icons/si"
import { SiMongodb } from "react-icons/si"
import Fade from "react-reveal/Fade"
const projects = [
  {
    name: "Overstock.com clone",
    img: "/overstock.png",
    link: "https://overstock-clone-2.netlify.app/",
    git: "https://github.com/SumitB1412/overstock-clone.git",
    about:
      "This is e-commerce website used for shopping wide range of products.This was a team project where I with my teammates had created. ",
    stacks: [
      <SiNodedotjs className={styles.stackIcon} />,
      <SiExpress className={styles.stackIcon} />,
      <SiMongodb className={styles.stackIcon} />,
      <SiJavascript className={styles.stackIcon} />,
      <SiCss3 className={styles.stackIcon} />,
    ],
  },
  {
    name: "Shopbop.com clone",
    img: "shopbop.jpeg",
    link: "https://shopbop.netlify.app/",
    git: "https://github.com/iShilajit/shopbopclone",
    about:
      " This is e-commerce application for Cloths and v. This was a team project where I with my teammates had created.",
    stacks: [
      <SiJavascript className={styles.stackIcon} />,
      <SiHtml5 className={styles.stackIcon} />,
      <SiCss3 className={styles.stackIcon} />,
    ],
  },
  {
    name: "Uboric.com clone",
    img: "/uboric.png",
    link: "https://github.com/punam102/exclusive-oatmeal-9602",
    git: "https://exclusive-oatmeal-9601.vercel.app",
    about:
      " It is an e-commerce website having varieties of luxury items which are of high quality. We have tried to clone the pixel perfect website with the help of HTML. Implemented using HTML, CSS and javascript.",
    stacks: [
      
      <SiJavascript className={styles.stackIcon} />,
      <SiHtml5 className={styles.stackIcon}/>,
      <SiCss3 className={styles.stackIcon}/>,
    ],
  },
  {
    name: "Headphonezone.com clone",
    img: "headphone.jpeg",
    link: "https://goofy-poitras-94a175.netlify.app/",
    git: "https://github.com/SankalpJaiswal/Head-Phone-Zone.git",
    about:
    "we learn about the fundamentals of Javascript and introduction to Data Structure and Algorithms,  By using these concepts we have built our project website..",
    stacks: [
      <SiJavascript className={styles.stackIcon} />,
      <SiHtml5 className={styles.stackIcon} />,
      <SiCss3 className={styles.stackIcon} />,
    ],
  }
]
export function ProjectsSection() {
  return (
    <div className={styles.projectsSectionCont} id="projects">
      <Fade bottom>
        <p>Projects</p>
      </Fade>
      <div className={styles.projectGrid}>
        {projects.map((project) => (
          <Fade bottom>
            <ProjectCard {...project} />
          </Fade>
        ))}
      </div>
    </div>
  )
}
